// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import DeliveryManagement from "../../components/dashboard/DeliveryManagement";

export default function DeliveryManagementPage() {
  return (
    <DashboardLayout>
      <DeliveryManagement />
    </DashboardLayout>
  );
}
